module.exports = __webpack_public_path__ + "img/ic_contentitem_tracking.4c743aab.svg";